export class GeogroupMember {
  constructor(id, username, joinDate, lastActivityDate, distance) {
    this.id = id;
    this.username = username;
    this.joinDate = joinDate;
    this.lastActivityDate = lastActivityDate;
    this.distance = distance;
  }
}